import { render, staticRenderFns } from "./sub-menu.vue?vue&type=template&id=3bdd081a&scoped=true&"
import script from "./sub-menu.vue?vue&type=script&lang=js&"
export * from "./sub-menu.vue?vue&type=script&lang=js&"
import style0 from "./sub-menu.vue?vue&type=style&index=0&id=3bdd081a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bdd081a",
  null
  
)

export default component.exports